import { createContext, useContext, useReducer } from "react";
import ISourceMapSaveDataBody from "../../contracts/ISourceMapSaveDataBody";
import { ICreateSourceMapFormAction } from "../../contracts/ICreateSourceMapFormAction";

interface IProps {
  children: JSX.Element;
}

const initialCreateSourceMapForm: ISourceMapSaveDataBody = {
  sourceMapLabel: "",
  sourceMapDesc: "",
  sourceMapType: "",
  active: false,
  emailTo: "",
  emailCc: "",
  emailBcc: "",
  csvDelimiter: "",
  username: "",
  password: "",
  protocolType: "",
  mefDependency: "",
  rootDirectory: "",
  hostServerName: "",
  ftpArchiveFolder: "",
  isAutoProcess: false,

  selectedDataSource: null,
  currentAvailableColumns: [],
};

export const CreateSourceMapContext = createContext<{
  createSourceMapForm: ISourceMapSaveDataBody;
  dispatch: React.Dispatch<ICreateSourceMapFormAction>;
} | null>(null);

const CreateSourceMapFormProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [createSourceMapForm, dispatch] = useReducer(
    createSourceMapFormReducer,
    initialCreateSourceMapForm
  );
  return (
    <CreateSourceMapContext.Provider value={{ createSourceMapForm, dispatch }}>
      {children}
    </CreateSourceMapContext.Provider>
  );
};
export default CreateSourceMapFormProvider;

export const createSourceMapFormReducer = (
  state: ISourceMapSaveDataBody,
  action: ICreateSourceMapFormAction
) => {
  switch (action.type) {
    case "UPDATE": {
      return {
        ...state,
        ...action.payload,
      };
    }

    default:
      return state;
  }
};
